module.exports = __webpack_public_path__ + "img/company_logo.fb6f7850.png";